import { Service, inject } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { GoogleService } from "./google-service";
import { Observable } from "rxjs";
import { Factor } from "../model/factor";
import { PersonLoginService } from "./person-login-service";
import { BrandID } from "../enums/brand-id";
import { EntityBreak } from "../entity/entity-break";

@Service()
export class ExtendedWarrantyService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);
  private readonly personLoginService = inject(PersonLoginService);
  private urlBase = environment.serviceUrl;

  addExtendedWarrantyBreaks(entityId: string, entityRevision: number, warrantyCodes: string[]): Observable<string> {
    const url = this.urlBase + "extendedWarranty/add/" + entityId + "/" + entityRevision;
    const body = JSON.stringify(warrantyCodes);
    return this.http.post(url, body, { headers: this.getPostHeaders(), responseType: "text" });
  }

  getExtendedWarrantyFactors(): Observable<Factor[]> {
    const brandID = this.personLoginService.getBrandIDs();
    const url = this.urlBase + "extendedWarranty/factors/" + brandID;
    return this.http.get<Factor[]>(url, { headers: this.getRequestHeaders() });
  }

  getCurrentExtendedWarrantyBreaks(entityId: string, entityRevision: number, brandId: BrandID): Observable<EntityBreak[]> {
    const url = this.urlBase + "extendedWarranty/currentbreaks/" + entityId + "/" + entityRevision + "/" + brandId;
    return this.http.get<EntityBreak[]>(url, { headers: this.getRequestHeaders() });
  }

  removeExistingExtendedWarrantyBreaks(entityId: string, entityRevision: number, brandId: BrandID): Observable<string> {
    const url = this.urlBase + "extendedWarranty/delete/" + entityId + "/" + entityRevision + "/" + brandId;
    return this.http.delete(url, { headers: this.getPostHeaders(), responseType: "text" });
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  getEntityBasePrice(entityId: string, revision: number): Observable<string> {
    const url = this.urlBase + "extendedWarranty/basePrice/" + entityId + "/" + revision;
    return this.http.get(url, { headers: this.getRequestHeaders(), responseType: "text" });
  }
}
